export default class DeletedComment {
    meetingCommentId: number
    message: string

    constructor(meetingCommentId: number, message: string) {
        this.meetingCommentId = meetingCommentId
        this.message = message
    }
}

